module.exports = __webpack_public_path__ + "img/2.38a2b901.jpeg";